import dayjs from 'dayjs';

import type { FilterOption } from '@shared/lib/types';
import type { DateFilterValue } from '@shared/ui/vanilla-calendar/lib/types';
import { Period } from '@shared/ui/vanilla-calendar/lib/types';
import { formatNumber as formatNumberByLocale } from '@shared/utils/format-number';

import { DATE_FORMAT } from './constants';

export const buildDefaultToday = (label: string): FilterOption<DateFilterValue>[] => {
  const today = dayjs();
  const startDate = today.startOf('day').format(DATE_FORMAT);
  const endDate = today.endOf('day').format(DATE_FORMAT);

  return [
    {
      label,
      value: {
        period: Period.CUSTOM,
        startDate,
        endDate,
      },
    },
  ];
};

export const buildDefaultYesterday = (label: string): FilterOption<DateFilterValue>[] => {
  const yesterday = dayjs().subtract(1, 'day');
  const startDate = yesterday.startOf('day').format(DATE_FORMAT);
  const endDate = yesterday.endOf('day').format(DATE_FORMAT);

  return [
    {
      label,
      value: {
        period: Period.YESTERDAY,
        startDate,
        endDate,
      },
    },
  ];
};

export const buildDefaultWeek = (label: string): FilterOption<DateFilterValue>[] => {
  const today = dayjs();
  const startDate = today.subtract(6, 'day').startOf('day').format(DATE_FORMAT);
  const endDate = today.endOf('day').format(DATE_FORMAT);

  return [
    {
      label,
      value: {
        period: Period.SEVEN_DAYS,
        startDate,
        endDate,
      },
    },
  ];
};

export const buildDefaultMonth = (label: string): FilterOption<DateFilterValue>[] => {
  const today = dayjs();
  const startDate = today.subtract(29, 'day').startOf('day').format(DATE_FORMAT);
  const endDate = today.endOf('day').format(DATE_FORMAT);

  return [
    {
      label,
      value: {
        period: Period.THIRTY_DAYS,
        startDate,
        endDate,
      },
    },
  ];
};

export const formatNumber = formatNumberByLocale;
